import { render, staticRenderFns } from "./UiToastList.vue?vue&type=template&id=608d8820&scoped=true&"
import script from "./UiToastList.vue?vue&type=script&lang=js&"
export * from "./UiToastList.vue?vue&type=script&lang=js&"
import style0 from "./UiToastList.vue?vue&type=style&index=0&id=608d8820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d8820",
  null
  
)

export default component.exports